export default {
  pluralRules: {
    ru: (n: number) => {
      const mod10 = n % 10
      const mod100 = n % 100

      if (mod10 === 1 && mod100 !== 11) return 0
      if (mod10 >= 2 && mod10 <= 4 && !(mod100 >= 12 && mod100 <= 14)) return 1
      return 2
    },

    ky: (n: number) => (Math.abs(n) === 1 ? 0 : 1)
  }
}
